import { createGtm } from "@gtm-support/vue-gtm"

export default defineNuxtPlugin({
  name: "GTM",
  dependsOn: ["CookieConsent", "CCM19"],
  async setup(nuxtApp) {
    /**
     * This appends the standard GTM script to the body
     * and enables the GTM Vue plugin.
     *
     * GTM itself might not be enabled really,
     * because CCM19 might have blocked it still
     */
    const { public: { gtm: { id } } } = useRuntimeConfig()
    const { data: jobShop } = useNuxtData("jobShopData")
    const { $cookieConsent } = useNuxtApp()

    const useMatomo = jobShop.value?.externalScriptSettings.isCookielessTrackingEnabled

    if (!useMatomo) {
      nuxtApp.vueApp.use(createGtm({
        id,
        enabled: false,
        loadScript: false,
        debug: import.meta.dev,
        trackViewEventProperty: "jobfinderView",
      }))

      function initializeGtmScript() {
        // Append comment before GTM script
        const startComment = document.createComment(" GTM Standard Script Start ")
        document.body.appendChild(startComment.cloneNode())

        // Create the noscript iframe for GTM
        const noscript = document.createElement("noscript")
        noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${id}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`

        // Append the noscript to the body
        document.body.appendChild(noscript)

        // Google's snippet wraps this in an inline <script>. We run it as module code
        // instead: browsers ignore 'unsafe-inline' as soon as a nonce or hash appears in
        // script-src, so an inline block would stop working the moment the CSP goes
        // enforcing (JET-2734). A src-only script element needs neither.
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({ "gtm.start": new Date().getTime(), "event": "gtm.js" })

        // Create the GTM script element
        const script = document.createElement("script")
        script.async = true
        script.src = `https://www.googletagmanager.com/gtm.js?id=${id}`

        // Append the script to the body
        document.body.appendChild(script)

        // Append comment after GTM script
        const endComment = document.createComment(" GTM Standard Script End ")
        document.body.appendChild(endComment.cloneNode())
      }

      function activatePlugin() {
        useGtm()?.enable(true)
      }

      // Check consent status whenever it changes
      watch($cookieConsent.checkConsent, (hasConsent) => {
        if (hasConsent) {
          initializeGtmScript()
          activatePlugin()
        }
      }, { immediate: true })
    }
  },
})
